/**
 * @generated SignedSource<<2289d1ee0c942323deb2678aaa1ecf7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SubtitleLanguage = "de" | "en";
import { FragmentRefs } from "relay-runtime";
export type VideoElement_ContentSubmissionDefinitionFragment$data = {
  readonly currentElementState: {
    readonly element: {
      readonly id: string;
      readonly streamFile?: {
        readonly url: string | null;
      } | null;
      readonly subtitles?: ReadonlyArray<{
        readonly language: SubtitleLanguage;
        readonly subtitles: ReadonlyArray<{
          readonly endTimeInSec: any;
          readonly startTimeInSec: any;
          readonly text: string;
        }>;
      }>;
      readonly thumbnailFile?: {
        readonly url: string | null;
      } | null;
      readonly title: string;
    };
  } | null;
  readonly " $fragmentType": "VideoElement_ContentSubmissionDefinitionFragment";
};
export type VideoElement_ContentSubmissionDefinitionFragment$key = {
  readonly " $data"?: VideoElement_ContentSubmissionDefinitionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoElement_ContentSubmissionDefinitionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VideoElement_ContentSubmissionDefinitionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentElementState",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "element",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StreamFile",
                  "kind": "LinkedField",
                  "name": "streamFile",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SubtitlesForLanguage",
                  "kind": "LinkedField",
                  "name": "subtitles",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "language",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "VideoSubtitle",
                      "kind": "LinkedField",
                      "name": "subtitles",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "startTimeInSec",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "endTimeInSec",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "text",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "File",
                  "kind": "LinkedField",
                  "name": "thumbnailFile",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                }
              ],
              "type": "VideoLearnElement",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ActiveELearningContentSubmissionDefinition",
  "abstractKey": null
};
})();

(node as any).hash = "44ecb2f2b03c92ae9bf72d784dd9504f";

export default node;
